import { useEffect, useState, useRef } from "react";
import carousel2 from "../assets/img/Banner1.jpg";
import carousel1 from "../assets/img/goals.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEmail } from "../hooks/useEmail";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import aboutImg from "../assets/img/ab.jpg"; // replace with correct path
import {
    faTimes, faUsers, faCheckCircle, faLightbulb, faCheck,
    faTrophy, faLaptop, faAward, faEye, faShieldAlt, faChartLine,
    faBars, faArrowRight, faLink, faQuoteRight
} from "@fortawesome/free-solid-svg-icons";
import service1 from '../assets/img/wealth.jpg'
import service2 from '../assets/img/service (2).jpg'
import service3 from '../assets/img/protection.jpg'
import service4 from '../assets/img/taxplanning.jpg'
import smc from '../assets/img/images.png'
import Care from '../assets/img/download.png'
import Uti from '../assets/img/Uti.jpg'
import star from '../assets/img/star.png'
import nippo from '../assets/img/nippo.png'
import tata from '../assets/img/tata (2).jpg'
import Bandhan from '../assets/img/Bandhan.jpg'
import Mirage from '../assets/img/Mirage.jpg'
import Max from '../assets/img/Max.jpg'
import Ppfas from '../assets/img/Ppfas.jpg'
import Bajaj from '../assets/img/Bajaj.svg'
import bgImage from '../assets/img/bg.png'
import t1 from '../assets/img/image.jpeg'
import t2 from '../assets/img/YatendraSolanki .jpg'
import t3 from '../assets/img/aditya.jpg'
import t4 from '../assets/img/ashwanimehra.jpg'
import founderImg from '../assets/img/meeting.jpg'
import { motion } from "framer-motion";
import retirment from '../assets/img/retirment.jpg'
import retirment1 from '../assets/img/retirment1.jpg'
import retirment2 from '../assets/img/retirment2.jpg'
import study from '../assets/img/study.jpg'
import study1 from '../assets/img/study1.jpg'
import study2 from '../assets/img/study2.jpg'
import FINANCIAL from '../assets/img/FINANCIAL.jpg'
import FINANCIAL2 from '../assets/img/financialimage.png'
import yashwin from '../assets/img/yashin dhawan.jpg'
import navneet from '../assets/img/navneet.jpg'
import paap from '../assets/img/paap.jpg'
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

const Home = () => {
    const isMobile = window.innerWidth < 768;

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) entry.target.classList.add("fade-in");
                });
            },
            { threshold: 0.1 }
        );

        document.querySelectorAll(".fade-on-scroll").forEach((el) => observer.observe(el));
    }, []);

    const { sendEmail, isSending } = useEmail();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        subjects: "",
        message: "",
    });

    // update state on input change
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { name, email, phone, city, topic, message, subjects } = formData;

        const emailMsg = `
        Name: ${name}
        Email: ${email}
        Phone: ${phone}
        City & State: ${city}
        Topic: ${topic}
        Message: ${message}
      `;

        const subject = `Request A Call-Back - ${subjects}`;
        try {
            await sendEmail(emailMsg, subject);

            setFormData({
                name: "",
                email: "",
                phone: "",
                city: "",
                topic: "",
                message: "",
            });
        } catch (err) {

            console.error(err);
        }
    };





    const responsive = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 1200 }, items: 3 },
        desktop: { breakpoint: { max: 1200, min: 992 }, items: 2 },
        tablet: { breakpoint: { max: 992, min: 576 }, items: 1 },
        mobile: { breakpoint: { max: 576, min: 0 }, items: 1 },
    };

    const projects = [
        { img: service1, title: "Wealth & Goal Planning" },
        { img: service2, title: "Investment Solutions" },
        { img: service3, title: "Protection Planning" },
        { img: service4, title: "Tax Planning & Loan Advisory" },
    ];



    const testimonials = [
        {
            img: paap,
            text: "As a finance professional, I understand taxes well, but SAG Financials brought fresh perspectives that optimized my savings. Their strategic advice on deductions, ELSS, and tax-efficient investments was practical and effective. Highly recommended for anyone wanting a professional yet personal advisory service.",
            name: "Naresh Mahawar",
            role: "Chartered Accountant",
        },
        {
            img: navneet,
            name: "Navniti Pd Singh",
            text: "For the past 20 years, I have been taking financial advice from Shepra Anand, Founder of SAG Financials. She and her team have always provided prompt, reliable service and are instantly available whenever I need guidance. Their dedication, transparency, and integrity have been the foundation of their growth. I highly recommend SAG Financials to anyone seeking professional financial and investment planning.",
            role: "Sr. Advocate , Supreme Court ",
        },
        {
            img: t3,
            text: "Before I met SAG Financials, I was overwhelmed by the choices in mutual funds and SIPs. Shepra and her team patiently explained everything, broke down complex terms into simple concepts, and tailored an investment plan that matched my goals. Now, I regularly track my portfolio and feel confident about my financial future. It’s been a transformative experience.",
            name: "Aditya Sharma",
            role: "Corporate Sales Professional",
        },
        {
            img: t4,
            text: "Planning for retirement felt overwhelming. SAG Financials guided me through creating a goal-based retirement plan suited to my lifestyle and risk appetite. Their team explained how to balance safe investments with growth options, and their tracking tools keep me updated regularly. I now look forward to retirement with confidence.",
            name: "Ashwani Mehra",
            role: "Ex-banker",
        },
        {
            img: yashwin,
            name: "Yashwin Dhawan",
            text: "Being in Corporate job , keeps me busy . SAG Financials assessed my personal profile & did financial need analysis.They recommended comprehensive protection plans that fit my budget. Their clear explanations helped me choose the right term insurance and health cover without confusion. It’s peace of mind that’s invaluable.",
            role: "IT Professional",
        },
        {
            img: t2,
            text: "I wanted to save for my children’s education and also start a small business but wasn’t sure how to balance both. SAG Financials helped me create a realistic plan aligned with my income and priorities. They never rushed me or pushed products — just honest advice and support. Their digital platform makes managing investments easy.",
            name: "Yatendra Solanki",
            role: "Entrepreneur",
        },



    ];
    const [activeTab, setActiveTab] = useState("tab1");

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
    const carouselRef = useRef(null);
    useEffect(() => {
        if (carouselRef.current) {
            new window.bootstrap.Carousel(carouselRef.current, {
                interval: 3000,
                ride: "carousel",
                pause: false
            });
        }
    }, []);

    return (
        <div className="container-fluid p-0 mb-5">
            <div
                id="header-carousel"
                className="carousel slide carousel-fade"
                data-bs-ride="carousel"
                data-bs-interval="3000"
                data-bs-pause="false"
                ref={carouselRef}

            >
                <div className="carousel-inner">

                    {/* ================= Slide 1 ================= */}
                    <div className="carousel-item active" style={{
                        background: 'linear-gradient(135deg, var(--primary) 0%, var(--accent) 50%, var(--heading) 100%)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        {/* Animated Background Elements */}
                        <div style={{
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            width: '100%',
                            height: '100%',
                            background: 'radial-gradient(circle at 20% 80%, rgba(0, 167, 147, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(0, 122, 89, 0.2) 0%, transparent 50%)',
                            zIndex: '1'
                        }}></div>

                        <div className="container-fluid position-relative" style={{ zIndex: '2' }}>
                            <div className="row align-items-center min-vh-70">

                                {/* LEFT IMAGE with Frame */}
                                <div className="col-md-6 p-0 position-relative">
                                    <div className="bannerimg" style={{
                                        padding: '15px',
                                        background: 'linear-gradient(145deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                                        borderRadius: '20px',
                                        margin: '20px 20px 0 20px'
                                        ,
                                        backdropFilter: 'blur(10px)',
                                        border: '1px solid rgba(255,255,255,0.2)',
                                        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',


                                    }}>
                                        <img src={carousel1} className="w-100 rounded-2 bannerunderimg" alt="Financial Growth" style={{
                                            filter: 'brightness(1.05) contrast(1.1)',
                                            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',

                                        }} />
                                    </div>
                                </div>

                                {/* RIGHT TEXT with Enhanced Design */}
                                <div className="col-md-6 d-flex flex-column justify-content-center p-5">
                                    {/* Animated Welcome Badge */}
                                    <div
                                        className="d-inline-block sagwelcome rounded-pill fw-bold py-2 px-4 mb-3 position-relative"
                                        style={{
                                            background: 'linear-gradient(135deg, var(--peacock-green) 0%, var(--hero-btn-hover) 100%)',
                                            color: 'var(--white)',
                                            fontSize: '16px',
                                            border: '2px solid rgba(255,255,255,0.3)',

                                            animation: 'pulse 2s infinite',
                                            width: 'fit-content'
                                        }}
                                    >
                                        <span className="d-flex align-items-center ">
                                            <span style={{
                                                width: '8px',
                                                height: '8px',
                                                background: 'var(--white)',
                                                borderRadius: '50%',
                                                marginRight: '10px',
                                                animation: 'blink 1.5s infinite'
                                            }}></span>
                                            Welcome to SAG Financials
                                        </span>
                                    </div>

                                    {/* Main Heading with Gradient Text */}
                                    <h2
                                        className="display-7 fw-bold mb-2 bannertage "
                                        style={{
                                            background: 'linear-gradient(135deg, #FFFFFF 0%, #E9F8FF 100%)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            backgroundClip: 'text',
                                            padding: '15px 15px',
                                            borderRadius: '15px',
                                            display: 'inline-block',
                                            textShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                            border: '1px solid rgba(255,255,255,0.1)',
                                            backdropFilter: 'blur(5px)',
                                            position: 'relative',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <div style={{
                                            position: 'absolute',
                                            top: '0',
                                            left: '-100%',
                                            width: '100%',
                                            height: '100%',
                                            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                                            animation: 'shimmer 3s infinite'
                                        }}></div>
                                        Turning Financial Goals Into Reality
                                    </h2>



                                </div>
                            </div>
                        </div>

                        {/* Enhanced Bottom Overlay */}
                        <div
                            className="position-absolute bottom-0 start-0 w-100 text-white text-center py-3"
                            style={{
                                background: 'linear-gradient(180deg, transparent 0%, rgba(10, 60, 70, 0.9) 100%)',
                                fontSize: '18px',
                                fontWeight: '600',
                                letterSpacing: '1px',
                                zIndex: '2'
                            }}
                        >
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <span className="d-flex align-items-center digital justify-content-center justify-content-lg-end"
                                            style={{ marginRight: '2%',marginLeft:'7%'}}>
                                            <span
                                                style={{
                                                    width: '6px',
                                                    height: '6px',
                                                    background: 'var(--peacock-green)',
                                                    borderRadius: '50%',
                                                    marginRight: '10px'
                                                }}
                                            ></span>
                                            100% Digital Financial Services
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ================= Slide 2 ================= */}
                    <div className="carousel-item" style={{
                        background: 'linear-gradient(135deg, var(--heading) 0%, var(--accent) 50%, var(--primary) 100%)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        {/* Animated Background Elements */}
                        <div style={{
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            width: '100%',
                            height: '100%',
                            background: 'radial-gradient(circle at 30% 70%, rgba(0, 122, 89, 0.25) 0%, transparent 50%), radial-gradient(circle at 70% 30%, rgba(0, 167, 147, 0.2) 0%, transparent 50%)',
                            zIndex: '1'
                        }}></div>

                        <div className="container-fluid position-relative" style={{ zIndex: '2' }}>
                            <div className="row align-items-center min-vh-70">

                                {/* LEFT IMAGE with Enhanced Frame */}
                                <div className="col-md-6 p-0 position-relative">
                                    <div className="bannerimg" style={{
                                        padding: '15px',
                                        background: 'linear-gradient(145deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                                        borderRadius: '20px',
                                        margin: '20px 20px 0 20px',

                                        backdropFilter: 'blur(10px)',
                                        border: '1px solid rgba(255,255,255,0.2)',
                                        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',


                                    }}
                                    >
                                        <img src={carousel2} className="w-100 rounded-3 bannerunderimg" alt="Financial Planning" style={{
                                            filter: 'brightness(1.08) contrast(1.15) saturate(1.1)',
                                            boxShadow: '0 15px 35px rgba(0,0,0,0.25)',


                                        }} />
                                    </div>
                                </div>

                                <div className="col-md-6 d-flex flex-column justify-content-center p-5">
                                    {/* Animated Welcome Badge */}
                                    <div
                                        className="d-inline-block sagwelcome rounded-pill fw-bold py-2 px-4 mb-3 position-relative"
                                        style={{
                                            background: 'linear-gradient(135deg, var(--peacock-green) 0%, var(--hero-btn-hover) 100%)',
                                            color: 'var(--white)',
                                            fontSize: '16px',
                                            border: '2px solid rgba(255,255,255,0.3)',

                                            animation: 'pulse 2s infinite',
                                            width: 'fit-content'
                                        }}
                                    >
                                        <span className="d-flex align-items-center ">
                                            <span style={{
                                                width: '8px',
                                                height: '8px',
                                                background: 'var(--white)',
                                                borderRadius: '50%',
                                                marginRight: '10px',
                                                animation: 'blink 1.5s infinite'
                                            }}></span>
                                            Welcome to SAG Financials
                                        </span>
                                    </div>

                                    {/* Main Heading with Gradient Text */}
                                    <h2
                                        className="display-7 fw-bold mb-2 bannertage "
                                        style={{
                                            background: 'linear-gradient(135deg, #FFFFFF 0%, #E9F8FF 100%)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            backgroundClip: 'text',
                                            padding: '15px 15px',
                                            borderRadius: '15px',
                                            display: 'inline-block',
                                            textShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                            border: '1px solid rgba(255,255,255,0.1)',
                                            backdropFilter: 'blur(5px)',
                                            position: 'relative',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <div style={{
                                            position: 'absolute',
                                            top: '0',
                                            left: '-100%',
                                            width: '100%',
                                            height: '100%',
                                            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                                            animation: 'shimmer 3s infinite'
                                        }}></div>
                                          True Financial Support For You
                                    </h2>



                                </div>
                            </div>
                        </div>

                        {/* Enhanced Bottom Overlay */}
                        <div
                            className="position-absolute bottom-0 start-0 w-100 text-white text-center py-3"
                            style={{
                                background: 'linear-gradient(180deg, transparent 0%, rgba(20, 78, 90, 0.95) 100%)',
                                fontSize: '18px',
                                fontWeight: '600',
                                letterSpacing: '1px',
                                zIndex: '2'
                            }}
                        >
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col text-center text-lg-start">
                                        <span className="d-flex align-items-center digital justify-content-center justify-content-lg-end"
                                            style={{ marginRight: '2%' ,marginLeft:'7%'}}>
                                            <span
                                                style={{
                                                    width: '6px',
                                                    height: '6px',
                                                    background: 'var(--peacock-green)',
                                                    borderRadius: '50%',
                                                    marginRight: '10px'
                                                }}
                                            ></span>
                                            100% Digital Financial Services
                                        </span>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Enhanced Controls */}
                <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#header-carousel"
                    data-bs-slide="prev"
                    style={{ zIndex: '3' }}
                >
                    <span className="carousel-control-prev-icon" style={{
                        backgroundSize: '30px',
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',


                    }}></span>
                </button>

                <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#header-carousel"
                    data-bs-slide="next"
                    style={{ zIndex: '3' }}
                >
                    <span className="carousel-control-next-icon" style={{
                        backgroundSize: '30px',
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',

                    }}></span>
                </button>
            </div>


            <section className="container py-3">
                <motion.div
                    className="text-center mb-4"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7 }}
                >
                    <h2>Financial Planning ... Investment Planning</h2>
                    <h6>Building Right Financial Portfolio For You !</h6>
                </motion.div>

                <div className="row justify-content-center">
                    {/* Image 1 */}
                    <motion.div
                        className="col-md-6 text-center mb-5"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <motion.img
                            src={FINANCIAL}
                            alt="Financial Planning"
                            className="img-fluid rounded shadow"
                            whileHover={{ scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 250 }}
                        />
                        <p className="mt-3 fw-semibold">
                            Smart Financial Planning for Joyful Happy Families.
                        </p>
                    </motion.div>

                    {/* Image 2 */}
                    <motion.div
                        className="col-md-6 text-center"
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                    >
                        <motion.img
                            src={FINANCIAL2}
                            alt="Investment Planning"
                            className="img-fluid rounded shadow"
                            whileHover={{ scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 250 }}
                        />
                        <p className="mt-3 fw-semibold">
                            From Goals to Growth to Great Family Life.
                        </p>
                    </motion.div>
                </div>
            </section>

            <section className="container-xxl about-section " style={{ backgroundColor: "var(--light-bg)" }}>
                <div className="container py-5">
                    <div className="row align-items-center g-5">
                        {/* Left Image */}
                        <div className="col-lg-5 text-center">
                            <motion.img
                                src={founderImg}
                                alt="Shepra Anand"
                                className="img-fluid rounded shadow-lg founder-img founderimg"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                                style={{
                                    border: "5px solid var(--secondary)",
                                    borderRadius: "1rem",
                                    height:'540px'
                                }}
                            />
                        </div>

                        {/* Right Text */}
                        <div className="col-lg-7">
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8, delay: 0.3 }}
                                style={{ color: "var(--dark)" }}
                            >
                                <p
                                    className="d-inline-block border rounded fw-semi-bold d-none py-1 px-3 mb-3"
                                    style={{
                                        color: "var(--primary)",
                                        borderColor: "var(--primary)",
                                        backgroundColor: "var(--white)",
                                    }}
                                >
                                    Welcome to SAG Financials
                                </p>

                                <h1
                                    className="display-6 mb-4"
                                    style={{
                                        color: "var(--heading)",
                                        fontWeight: "700",
                                    }}
                                >
                                    Your Partner in Wealth Creation, Protection & Financial Well-Being
                                </h1>

                                <p
                                    className=" mb-4"
                                    style={{
                                        color: "var(--highlight)",
                                        fontSize: "1.05rem",
                                    }}
                                >
                                    SAG Financials aims  to provide 100% Digital One Point Solutions for various segments of Financial services.
                                    At SAG , we help individuals and families achieve their financial goals through transparent, digital - first and personalized financial planning solutions.
                                </p>



                                <motion.div
                                    className="border rounded p-4 shadow-sm"
                                    initial={{ opacity: 0, sccd: 0.9 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.6, delay: 0.5 }}
                                    style={{
                                        backgroundColor: "var(--white)",
                                        borderColor: "var(--secondary) !important",
                                    }}
                                >
                                    <h4
                                        className="mb-3"
                                        style={{
                                            color: "var(--primary)",
                                            fontWeight: "600",
                                        }}
                                    >
                                        Trusted Financial Advice Backed by 22+ Years of Experience
                                    </h4>

                                    <p className="mb-3" style={{ color: "var(--text)" }}>
                                        Led by <strong>Shepra Anand</strong>, Founder & CEO, SAG Financials brings
                                        over 22 years of rich experience in the financial services industry. Our
                                        journey started with some of India’s most respected corporate financial institutions like ICICI Bank, IDBI , Aditya Birla Sun Life etc.
                                    </p>
                                    <p className="mb-4" style={{ color: "var(--text)" }}>
                                        We aim to provide a One Point solution to our clients for all their Financial Needs with Simple, Unbiased Professional Advice and Solutions.
                                        We offer services through personal advisory which leads to comprehensive, competent, customized, and best solutions in wealth creation and wealth management.
                                    </p>

                                </motion.div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>

            <div
                className="container-xxl py-1"
                style={{ backgroundColor: "var(--light-bg)" }}
            >
                <div className="container">
                    {/* ==================== TOP ROW ==================== */}
                    <div className="row g-4 align-items-end mb-4">
                        {/* Left Image */}
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <img
                                className="img-fluid rounded shadow-lg"
                                src={aboutImg}
                                alt="About Us"
                                style={{
                                    border: "5px solid var(--secondary)",
                                    borderRadius: "1rem",
                                    height: '450px',
                                    objectFit: 'cover'
                                }}
                            />
                        </div>

                        {/* Right Text */}
                        <div
                            className="col-lg-6 wow fadeInUp "
                            data-wow-delay="0.3s"
                            style={{ color: "var(--dark)" }}
                        >
                            <p
                                className="d-inline-block border rounded fw-bold py-1 px-3 aboutus"
                                style={{
                                    color: "var(--primary)",
                                    borderColor: "var(--primary)",
                                    backgroundColor: "var(--white)",
                                }}
                            >
                                About Us
                            </p>

                            <h1
                                className="display-5 mb-4"
                                style={{
                                    color: "var(--heading)",
                                    fontWeight: "700",
                                }}
                            >
                                We Help Our Clients To Grow Their Money
                            </h1>

                            <p className="mb-4" style={{ color: "var(--text)" }}>
                                SAG Financials works with clients at every stage of their financial
                                journey. We assist working professionals planning for the future,
                                families focused on education and protection, retirees seeking secure
                                income options, and entrepreneurs needing structured financial plans.
                                Whether you’re just starting out or looking to rebalance your
                                investments, we’re here to provide guidance and support every step of
                                the way.
                            </p>

                            {/* ==================== TABS ==================== */}
                            <div
                                className="border rounded p-4 shadow-sm"
                                style={{
                                    borderColor: "var(--secondary) !important",
                                    backgroundColor: "var(--white)",
                                }}
                            >
                                <nav>
                                    <div
                                        className="nav nav-tabs justify-content-center mb-3" style={{ borderBottom: "2px solid var(--primary)" }}
                                        id="nav-tab"
                                        role="tablist"
                                    >
                                        {["Our Vision"].map((tab, i) => (
                                            <box
                                                style={{ fontSize: '17px', fontWeight: 'bold', position: 'relative', bottom: '10px' }}
                                            >
                                                {tab}
                                            </box>
                                        ))}
                                    </div>
                                </nav>

                                {/* TAB CONTENT */}
                                <div
                                    className="tab-content "
                                    id="nav-tabContent"
                                    style={{ color: "var(--text)" }}
                                >
                                    <div
                                        className="tab-pane fade show active "
                                        id="nav-vision"
                                        role="tabpanel"
                                        aria-labelledby="nav-vision-tab"
                                        style={{ maxWidth: "700px" }}
                                    >
                                        <p className="mx-auto" style={{ fontSize: "1rem", lineHeight: "1.7" }}>
                                            To be a reliable financial partner that educates, guides, and empowers
                                            clients to make informed decisions for wealth creation, protection, and
                                            long-term financial well-being.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* ==================== BOTTOM FEATURES ==================== */}
                    <div
                        className="border rounded p-4 wow fadeInUp mt-5"
                        data-wow-delay="0.1s"
                        style={{
                            borderColor: "var(--secondary)",
                            backgroundColor: "var(--white)",
                            color: "var(--dark)",
                        }}
                    >
                        <div className="row g-4">
                            {[
                                {
                                    icon: faCheck,
                                    title: " Full Transparency",
                                    text: " Transparent processes for all clients.",
                                },
                                {
                                    icon: faUsers,
                                    title: "Dedicated Team",
                                    text: "Our experts work with you personally.",
                                },
                                {
                                    icon: faLightbulb,
                                    title: "Creative Solutions",
                                    text: "We bring ideas & strategies to solutions.",
                                }
                            ].map((item, i) => (
                                <div
                                    className="col-lg-4 wow fadeIn"
                                    data-wow-delay={`${0.1 + i * 0.2}s`}
                                    key={i}
                                >
                                    <div className="h-100">
                                        <div className="d-flex align-items-start">
                                            <div
                                                className="flex-shrink-0 btn-lg-square rounded-circle d-flex align-items-center justify-content-center"
                                                style={{
                                                    backgroundColor: "var(--primary)",
                                                    width: "60px",
                                                    height: "60px",
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={item.icon}
                                                    style={{ color: "var(--white)", fontSize: "1.2rem" }}
                                                />
                                            </div>
                                            <div className="ps-3">
                                                <h4
                                                    style={{
                                                        color: "var(--heading)",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    {item.title}
                                                </h4>
                                                <span style={{ color: "var(--text)" }}>{item.text}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {/* <Fact /> */}

            <section className="container-xxl feature py-5" style={{ backgroundColor: "var(--light-bg)" }}>
                <div className="container">
                    <div className="row g-5 align-items-center">
                        {/* ===== Left Section ===== */}
                        <div className="col-lg-5" data-wow-delay="0.1s" style={{ animation: "fadeInUp 0.8s ease" }}>
                            <div className="d-flex align-items-center mb-3">
                                <p className="d-inline-block border rounded fw-bold py-1 px-3"
                                    style={{
                                        color: "var(--primary)",
                                        borderColor: "var(--primary)",
                                        backgroundColor: "var(--white)",
                                        fontSize: '20px'
                                    }}>
                                    Why Choose SAG Financials ?
                                </p>
                            </div>

                            <h1 className="display-6 mb-4 fw-bold gradient-text"
                                style={{
                                    background: "linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "black",
                                    backgroundClip: "text",

                                }}>
                                Few Reasons Why People Choosing Us !
                            </h1>

                            <p className="mb-4 fs-5" style={{ color: "var(--text)", lineHeight: "1.5" }}>
                                We're not just advisors — we're your partners in achieving financial freedom.
                                Here's why hundreds of clients trust us with their financial future.
                            </p>

                            <div className="row g-3 mb-4">
                                {[
                                    { text: "Trusted 22+ Years Expertise", icon: "faCheck" },
                                    { text: "AMFI, IRDA & NISM Certified", icon: "faCheckCircle" },
                                    { text: "100% Transparent Processes", icon: "faCheckCircle" },
                                    { text: "Client-Centric Approach", icon: "faCheckCircle" },
                                    { text: "MDRT Award Winning Team", icon: "faCheck" },
                                    { text: "Holistic Financial Planning", icon: "faCheck" }
                                ].map((feature, index) => (
                                    <div className="col-12" key={index}>
                                        <div className="d-flex align-items-center p-3 rounded-3 feature-list-item"
                                            style={{
                                                transition: "all 0.3s ease",
                                                backgroundColor: "rgba(255,255,255,0.7)"

                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = "rgba(var(--primary-rgb), 0.05)";
                                                e.currentTarget.style.transform = "translateX(5px)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.7)";
                                                e.currentTarget.style.transform = "translateX(0)";
                                            }}>
                                            <div className="feature-icon-wrapper rounded-circle d-flex align-items-center justify-content-center me-3"
                                                style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    backgroundColor: "rgba(var(--primary-rgb), 0.1)",
                                                    color: "var(--primary)",
                                                    border: '1px solid var(--primary)',
                                                    flexShrink: 0
                                                }}>
                                                <FontAwesomeIcon
                                                    icon={feature.icon === "faShieldAlt" ? faCheck :
                                                        feature.icon === "faAward" ? faCheck :
                                                            feature.icon === "faEye" ? faCheck :
                                                                feature.icon === "faUsers" ? faCheck :
                                                                    feature.icon === "faTrophy" ? faTrophy : faCheck}
                                                    style={{ fontSize: "1rem" }}
                                                />
                                            </div>
                                            <span style={{ color: "var(--text)", fontWeight: "500" }}>{feature.text}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>


                        </div>

                        {/* ===== Right Section - Enhanced Grid ===== */}
                        <div className="col-lg-7">
                            <div className="row g-4">
                                {[
                                    {
                                        title: "Trusted Expertise",
                                        description: "22+ Years of Expertise - Decades of proven experience across wealth management, Insurance & tax planning.",
                                        icon: faShieldAlt,
                                        color: "var(--primary)"
                                    },
                                    {
                                        title: "Full Transparency",
                                        description: "Complete clarity in all our processes and recommendations.",
                                        icon: faEye,
                                        color: "var(--secondary)"
                                    },
                                    {
                                        title: "Certified & Recognized",
                                        description: "We're AMFI, IRDA and NISM certified advisors & distributors. Our advisory meets the highest professional & ethical standards.",
                                        icon: faAward,
                                        color: "var(--primary)"
                                    },
                                    {
                                        title: "Client-Centric Approach",
                                        description: "We focus on what's right for you, not what sells. Your success is our primary goal.",
                                        icon: faUsers,
                                        color: "var(--secondary)"
                                    },
                                    {
                                        title: "100% Digital, 100% Human",
                                        description: "Convenience meets personal support. Digital processes with human touch and understanding.",
                                        icon: faLaptop,
                                        color: "var(--primary)"
                                    },
                                    {
                                        title: "MDRT Achievement",
                                        description: "Honoured with Million Dollar Round Table (MDRT) - An achievement of International recognition.",
                                        icon: faTrophy,
                                        color: "var(--secondary)"
                                    }
                                ].map((feature, index) => (
                                    <div className="col-md-6" key={index}>
                                        <div className="feature-card rounded-4 p-4 h-100 position-relative overflow-hidden"
                                            style={{
                                                backgroundColor: "var(--white)",
                                                border: "1px solid var(--primary) !important",
                                                transition: "all 0.4s ease",
                                                boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = "translateY(-8px)";
                                                e.currentTarget.style.boxShadow = "0 15px 30px rgba(0,0,0,0.1)";
                                                e.currentTarget.style.background = "var(--primary)";
                                                const heading = e.currentTarget.querySelector("h4");
                                                const para = e.currentTarget.querySelector("p");
                                                const iconBox = e.currentTarget.querySelector(".feature-icon");

                                                // Apply correct colors
                                                if (iconBox) iconBox.style.color = "var(--white)";
                                                if (heading) heading.style.color = "var(--white)";
                                                if (para) para.style.color = "var(--white)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = "translateY(0)";
                                                e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.05)";
                                                e.currentTarget.style.background = "var(--white)";
                                                const heading = e.currentTarget.querySelector("h4");
                                                const para = e.currentTarget.querySelector("p");
                                                const iconBox = e.currentTarget.querySelector(".feature-icon");

                                                // Apply correct colors
                                                if (iconBox) iconBox.style.color = feature.color;
                                                if (heading) heading.style.color = "var(--heading)";
                                                if (para) para.style.color = "var(--text)";
                                            }}>
                                            <div className="feature-card-bg"
                                                style={{
                                                    position: "absolute",
                                                    top: "0",
                                                    right: "0",
                                                    width: "80px",
                                                    height: "80px",
                                                    backgroundColor: "rgba(var(--primary-rgb), 0.03)",
                                                    borderRadius: "0 0 0 80px",
                                                    zIndex: "0"
                                                }}></div>

                                            <div className="feature-icon mb-3 position-relative z-1"
                                                style={{
                                                    width: "60px",
                                                    height: "60px",
                                                    borderRadius: "12px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    backgroundColor: "rgba(var(--primary-rgb), 0.1)",
                                                    color: feature.color
                                                }}>
                                                <FontAwesomeIcon icon={feature.icon} style={{ fontSize: "1.8rem" }} />
                                            </div>

                                            <h4 className="mb-3 position-relative z-1"
                                                style={{
                                                    color: "var(--heading)",
                                                    fontWeight: "700",
                                                    fontSize: "1.3rem"
                                                }}>
                                                {feature.title}
                                            </h4>

                                            <p className="mb-0 position-relative z-1"
                                                style={{
                                                    color: "var(--text)",
                                                    lineHeight: "1.6"
                                                }}>
                                                {feature.description}
                                            </p>

                                            <div className="feature-hover-line position-absolute bottom-0 start-0"
                                                style={{
                                                    height: "3px",
                                                    width: "0",
                                                    backgroundColor: feature.color,
                                                    transition: "width 0.4s ease"
                                                }}></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section
                className="container-xxl service py-2"
                style={{ backgroundColor: "var(--light-bg)", position: 'relative', }}
            >
                <div className="container">
                    {/* Section Header */}
                    <div
                        className="text-center mx-auto"
                        style={{ maxWidth: "600px" }}
                    >
                        <p
                            className="d-inline-block border rounded fw-bold py-1 px-3"
                            style={{
                                color: "var(--primary)",
                                borderColor: "var(--primary)",
                                backgroundColor: "var(--white)",
                            }}
                        >
                            Our Services
                        </p>
                        <h1
                            className="display-5 mb-5"
                            style={{
                                color: "var(--heading)",
                                fontWeight: "700",
                            }}
                        >

                            Our Financial Services For Your Wealth Creation
                        </h1>
                    </div>

                    <div className="row g-4">
                        {/* Left Nav */}
                        <div className="col-lg-4">
                            <div className="nav flex-column nav-pills d-flex justify-content-between w-100 h-100 me-4">
                                {[
                                    { id: "tab1", title: "Wealth & Goal Planning" },
                                    { id: "tab2", title: "Investment Solutions" },
                                    { id: "tab3", title: "Protection Planning" },
                                    { id: "tab4", title: "Tax Planning & Loan Advisory" },
                                ].map((tab) => (
                                    <button
                                        key={tab.id}
                                        className={`nav-link w-100 d-flex align-items-center text-start border p-3 mb-3 ${activeTab === tab.id ? "active" : ""
                                            }`}
                                        type="button"
                                        onClick={() => handleTabChange(tab.id)}
                                        style={{
                                            backgroundColor:
                                                activeTab === tab.id ? "var(--primary)" : "var(--white)",
                                            color:
                                                activeTab === tab.id ? "var(--white)" : "var(--dark)",
                                            borderColor: "var(--secondary)",
                                            fontWeight: "500",
                                            borderRadius: "6px",
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        <h5 className="m-0">
                                            <FontAwesomeIcon
                                                icon={faBars}
                                                style={{
                                                    color:
                                                        activeTab === tab.id
                                                            ? "var(--white)"
                                                            : "var(--primary)",
                                                    marginRight: "12px",
                                                }}
                                            />
                                            {tab.title}
                                        </h5>
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Right Content */}
                        <div className="col-lg-8">
                            <div className="tab-content w-100">
                                {/* Tab 1 */}
                                {activeTab === "tab1" && (
                                    <div className="tab-pane fade show active">
                                        <div className="row g-4">
                                            <div className="col-md-6" style={{ minHeight: "350px" }}>
                                                <div className="position-relative h-100">
                                                    <img
                                                        className="position-absolute rounded w-100 h-100"
                                                        src={service1}
                                                        alt="Wealth & Goal Planning"
                                                        style={{

                                                            border: "4px solid var(--secondary)",
                                                            borderRadius: "1rem",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                className="col-md-6"
                                                style={{ color: "var(--text)" }}
                                            >
                                                <h3
                                                    className="mb-4"
                                                    style={{ color: "var(--heading)", fontWeight: "600" }}
                                                >
                                                    22 Years Of  Expertise In Wealth & Goal Planning
                                                </h3>
                                                <p className="mb-4">
                                                    Helping clients set and achieve their wealth and life
                                                    goals with personalized planning, clarity, and
                                                    confidence.
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Retirement Planning
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Child Education Planning
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Marriage Planning
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Vacation Planning
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Investment Planning
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Tab 2 */}
                                {activeTab === "tab2" && (
                                    <div className="tab-pane fade show active">
                                        <div className="row g-4">
                                            <div className="col-md-6" style={{ minHeight: "350px" }}>
                                                <div className="position-relative h-100">
                                                    <img
                                                        className="position-absolute rounded w-100 h-100 "
                                                        src={service2}
                                                        alt="Investment Solutions"
                                                        style={{

                                                            border: "4px solid var(--secondary)",
                                                            borderRadius: "1rem",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6" style={{ color: "var(--text)" }}>
                                                <h3
                                                    className="mb-4"
                                                    style={{ color: "var(--heading)", fontWeight: "600" }}
                                                >
                                                    22 Years of Expertise In Investment Solutions
                                                </h3>
                                                <p className="mb-4">
                                                    Customized investment strategies designed to maximize
                                                    returns and minimize risk for all life stages.
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Mutual Funds & SIPs
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Portfolio Management
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Bonds & FDs
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Digital Gold & Silver Investment
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Tab 3 */}
                                {activeTab === "tab3" && (
                                    <div className="tab-pane fade show active">
                                        <div className="row g-4">
                                            <div className="col-md-6" style={{ minHeight: "350px" }}>
                                                <div className="position-relative h-100">
                                                    <img
                                                        className="position-absolute rounded w-100 h-100"
                                                        src={service3}
                                                        alt="Protection Planning"
                                                        style={{

                                                            border: "4px solid var(--secondary)",
                                                            borderRadius: "1rem",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6" style={{ color: "var(--text)" }}>
                                                <h3
                                                    className="mb-4"
                                                    style={{ color: "var(--heading)", fontWeight: "600" }}
                                                >
                                                    22 Years of Expertise In Protection Planning
                                                </h3>
                                                <p className="mb-4">
                                                    Ensuring you and your family are financially secure with
                                                    appropriate protection and insurance plans.
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Life & Health Insurance
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Critical Illness Coverage
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Term plan with Income Protection.
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Personal Accidental Coverage
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Tab 4 */}
                                {activeTab === "tab4" && (
                                    <div className="tab-pane fade show active">
                                        <div className="row g-4">
                                            <div className="col-md-6" style={{ minHeight: "350px" }}>
                                                <div className="position-relative h-100">
                                                    <img
                                                        className="position-absolute rounded w-100 h-100"
                                                        src={service4}
                                                        alt="Tax Planning & Loan Advisory"
                                                        style={{

                                                            border: "4px solid var(--secondary)",
                                                            borderRadius: "1rem",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6" style={{ color: "var(--text)" }}>
                                                <h3
                                                    className="mb-4"
                                                    style={{ color: "var(--heading)", fontWeight: "600" }}
                                                >
                                                    Our Expertise in Loan Advisory & Tax Filing
                                                </h3>
                                                <p className="mb-4">
                                                    Optimized tax planning and loan solutions tailored for
                                                    businesses and individuals.
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Tax Planning & Filing
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Loan Structuring & Advisory
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Financial Compliance Guidance
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        style={{
                                                            color: "var(--primary)",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    Processing - Home Loans , Business  Loan etc.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>

                    </div>
                </div>
                <section className="container py-4 mt-2">
                    <div className="row text-center ">
                        <h2>Education Planning </h2>
                        <p>An investment in knowledge pays the best interest.</p>
                    </div>


                    <div className="row g-4 align-items-center">
                        <div className="col-md-4 text-center">
                            <img
                                src={study}
                                alt="Retirement Savings"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">Plan today for a brighter tomorrow.</p>
                        </div>

                        <div className="col-md-4 text-center">
                            <img
                                src={study1}
                                alt="Secure Future"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold"> Invest in your child's future.</p>
                        </div>

                        <div className="col-md-4 text-center">
                            <img
                                src={study2}
                                alt="Wisdom Plan"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">Let Your Child's DREAM take a FLIGHT !</p>
                        </div>
                    </div>
                </section>
                <section className="container py-4">
                    <div className="row text-center mb-2">
                        <h2>Retirement Planning</h2>
                        <p>Plan with Wisdom, Retire in Freedom</p>
                    </div>


                    <div className="row g-4 align-items-center">
                        <div className="col-md-4 text-center">
                            <img
                                src={retirment}
                                alt="Retirement Savings"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">Savings Today, Smiles Tomorrow</p>
                        </div>

                        <div className="col-md-4 text-center">
                            <img
                                src={retirment1}
                                alt="Secure Future"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">Your Path to a Carefree Tomorrow</p>
                        </div>

                        <div className="col-md-4 text-center">
                            <img
                                src={retirment2}
                                alt="Wisdom Plan"
                                className="img-fluid rounded shadow"
                            />
                            <p className="mt-3 fw-semibold">Retire with Confidence</p>
                        </div>
                    </div>
                </section>

            </section>

            <section
                className="container-fluid callback pt-5 position-relative"
                style={{ overflow: "hidden" }}
            >
                {/* ✅ Background layer replacing ::before */}
                <div
                    style={{
                        position: "absolute",
                        content: '""',
                        width: "100%",
                        height: "50%",
                        top: 0,
                        left: 0,
                        zIndex: -1,
                        background: `linear-gradient(rgba(0,119,125,0.95), rgba(0,119,125,0.95)), url(${bgImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                ></div>

                <div className="container pt-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <div
                                className="bg-white border rounded p-4 p-sm-5 shadow-sm"
                                style={{
                                    borderColor: "var(--secondary) !important",
                                    backgroundColor: "var(--white)",
                                }}
                            >
                                {/* Header */}
                                <div
                                    className="text-center mx-auto mb-4"
                                    style={{ maxWidth: "600px" }}
                                >
                                    <p
                                        className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                                        style={{
                                            color: "var(--primary)",
                                            borderColor: "var(--primary)",
                                            backgroundColor: "var(--white)",
                                        }}
                                    >
                                        Get In Touch
                                    </p>
                                    <h1
                                        className="display-5 mb-4"
                                        style={{ color: "var(--heading)", fontWeight: "700" }}
                                    >
                                        Request A Call-Back
                                    </h1>
                                </div>

                                {/* Form */}
                                <form onSubmit={handleSubmit}>
                                    <div className="row g-3">
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    placeholder="Your Name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                    style={{
                                                        borderColor: "var(--secondary)",
                                                        color: "var(--dark)",
                                                    }}
                                                />
                                                <label htmlFor="name" style={{ color: "var(--text)" }}>
                                                    Your Name
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="email"
                                                    placeholder="Your Email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                    style={{
                                                        borderColor: "var(--secondary)",
                                                        color: "var(--dark)",
                                                    }}
                                                />
                                                <label htmlFor="email" style={{ color: "var(--text)" }}>
                                                    Your Email
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="mobile"
                                                    placeholder="Your Mobile"
                                                    value={formData.mobile}
                                                    onChange={handleChange}
                                                    style={{
                                                        borderColor: "var(--secondary)",
                                                        color: "var(--dark)",
                                                    }}
                                                />
                                                <label htmlFor="mobile" style={{ color: "var(--text)" }}>
                                                    Your Mobile
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="subjects"
                                                    placeholder="Subject"
                                                    value={formData.subjects}
                                                    onChange={handleChange}
                                                    style={{
                                                        borderColor: "var(--secondary)",
                                                        color: "var(--dark)",
                                                    }}
                                                />
                                                <label htmlFor="subject" style={{ color: "var(--text)" }}>
                                                    Subject
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-floating">
                                                <textarea
                                                    className="form-control"
                                                    id="message"
                                                    placeholder="Leave a message here"
                                                    style={{
                                                        height: "100px",
                                                        borderColor: "var(--secondary)",
                                                        color: "var(--dark)",
                                                    }}
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="message" style={{ color: "var(--text)" }}>
                                                    Message
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-12 text-center">
                                            <button
                                                className="btn w-100 py-3"
                                                type="submit"
                                                style={{
                                                    backgroundColor: "var(--primary)",
                                                    color: "var(--white)",
                                                    border: "none",
                                                    borderRadius: "6px",
                                                    fontWeight: "500",
                                                    transition: "all 0.3s ease",
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = "var(--secondary)";
                                                    e.currentTarget.style.color = "var(--dark)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = "var(--primary)";
                                                    e.currentTarget.style.color = "var(--white)";
                                                }}
                                            >
                                                Submit Now
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container-xxl py-5 d-none" style={{ backgroundColor: "var(--light-bg)" }}>
                <div className="container">
                    <div
                        className="text-center mx-auto"
                        style={{ maxWidth: "600px" }}
                    >
                        <p
                            className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                            style={{
                                color: "var(--primary)",
                                borderColor: "var(--primary)",
                                backgroundColor: "var(--white)",
                            }}
                        >
                            Our Projects
                        </p>
                        <h1
                            className="display-5 mb-5"
                            style={{ color: "var(--heading)", fontWeight: "700" }}
                        >
                            We Have Completed Latest Projects
                        </h1>
                    </div>

                    {/* ✅ React Multi Carousel */}
                    <Carousel
                        responsive={responsive}
                        infinite={true}
                        autoPlay={true}
                        autoPlaySpeed={3000}
                        showDots={true}
                        arrows={false}
                        className="project-carousel"
                    >
                        {projects.map((project, i) => (
                            <div key={i} className="project-item pe-4 pb-5">
                                <div
                                    className="project-img mb-3 position-relative"
                                    style={{
                                        border: "4px solid var(--secondary)",
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        transition: "transform 0.4s ease, box-shadow 0.4s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-6px)";
                                        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "none";
                                    }}
                                >
                                    <img
                                        className="img-fluid rounded w-100"
                                        src={project.img}
                                        alt={project.title}
                                        style={{ objectFit: "cover" }}
                                    />
                                    <a
                                        href="#"
                                        className="project-link d-flex justify-content-center align-items-center"
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            background: "rgba(0,119,125,0.7)",
                                            opacity: 0,
                                            transition: "opacity 0.4s ease",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
                                        onMouseLeave={(e) => (e.currentTarget.style.opacity = "0")}
                                    >
                                        <FontAwesomeIcon
                                            icon={faLink}
                                            className="fa-3x"
                                            style={{ color: "var(--white)" }}
                                        />
                                    </a>
                                </div>
                                <div className="project-title text-center">
                                    <h4 className="mb-0" style={{ color: "var(--heading)" }}>
                                        {project.title}
                                    </h4>
                                </div>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </section>



            <section
                className="container-xxl py-5"
                style={{ backgroundColor: "var(--light-bg)" }}
            >
                <div className="container">
                    <div
                        className="text-center mx-auto"
                        style={{ maxWidth: "600px" }}
                    >
                        <p
                            className="d-inline-block border rounded fw-bold py-1 px-3"
                            style={{
                                color: "var(--primary)",
                                borderColor: "var(--primary)",
                                backgroundColor: "var(--white)",
                            }}
                        >
                            Testimonials
                        </p>
                        {
                            isMobile ? (
                                <h5
                                    className="display-7 mb-5"
                                    style={{ color: "var(--heading)", fontWeight: "700" }}
                                >
                                    What Our Clients Say About Us !
                                </h5>
                            ) : (
                                <h3
                                    className="display-7 mb-5"
                                    style={{ color: "var(--heading)", fontWeight: "700" }}
                                >
                                    What Our Clients Say About Us !
                                </h3>
                            )
                        }

                    </div>

                    <Carousel
                        responsive={responsive}
                        infinite={true}
                        autoPlay={true}
                        autoPlaySpeed={4000}
                        showDots={true}
                        arrows={false}
                        className="testimonial-carousel"
                        pauseOnHover={false}

                    >
                        {testimonials.map((item, i) => (
                            <div
                                key={i}
                                className="testimonial-item text-center px-3 pb-5"
                                style={{ animation: "fadeInUp 0.8s ease", animationDelay: `${0.2 * i}s`, width: '100%' }}
                            >
                                <div
                                    className="testimonial-text border rounded p-3 pt-5 mb-5 position-relative"
                                    style={{
                                        backgroundColor: "var(--white)",
                                        borderColor: "var(--secondary)",
                                        boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                                        transition: "transform 0.4s ease, box-shadow 0.4s ease",
                                        height: '360px',

                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-6px)";
                                        e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)";
                                    }}
                                >
                                    <div
                                        className="btn-square border rounded-circle position-absolute top-0 start-50 translate-middle"
                                        style={{
                                            backgroundColor: "var(--secondary)",
                                            width: "60px",
                                            height: "60px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faQuoteRight}
                                            className="fa-2x"
                                            style={{ color: "var(--white)" }}
                                        />
                                    </div>

                                    <p
                                        className=""
                                        style={{
                                            color: "var(--text)",
                                            fontStyle: "italic",
                                            lineHeight: "1.7",
                                            fontSize: "15px"
                                        }}
                                    >
                                        {item.text}
                                    </p>
                                </div>

                                <img
                                    className="rounded-circle mb-3"
                                    src={item.img}
                                    alt={item.name}
                                    style={{
                                        width: "80px",
                                        height: "80px",
                                        objectFit: "cover",
                                        border: "3px solid var(--secondary)",
                                    }}
                                />
                                <h4
                                    className="mb-0"
                                    style={{ color: "var(--heading)", fontWeight: "600" }}
                                >
                                    {item.name}
                                </h4>
                                <span style={{ color: "var(--primary)" }}>{item.role}</span>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </section>


            <section className="py-5" style={{ backgroundColor: "var(--white)" }}>
                <div className="container">
                    {/* Section Title */}
                    <motion.div
                        className="text-center mb-5"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                    >
                        <h3 className="fw-bold" style={{ color: "var(--heading)" }}>
                            Associated With
                        </h3>
                        <div
                            style={{
                                height: "3px",
                                width: "200px",
                                backgroundColor: "var(--primary)",
                                margin: "8px auto 0",
                                borderRadius: "2px"
                            }}
                        ></div>
                    </motion.div>

                    {/* Moving Brands Container */}
                    <div className="position-relative overflow-hidden py-4">
                        {/* Gradient Overlays */}
                        <div
                            style={{
                                position: "absolute",
                                left: 0,
                                top: 0,
                                bottom: 0,
                                width: "100px",
                                background: "linear-gradient(90deg, var(--white) 0%, transparent 100%)",
                                zIndex: 2
                            }}
                        ></div>
                        <div
                            style={{
                                position: "absolute",
                                right: 0,
                                top: 0,
                                bottom: 0,
                                width: "100px",
                                background: "linear-gradient(270deg, var(--white) 0%, transparent 100%)",
                                zIndex: 2
                            }}
                        ></div>

                        {/* Moving Brands - First Set */}
                        <motion.div
                            className="brand-row d-flex align-items-center companybrand"
                            initial={{ x: 0 }}
                            animate={{ x: "-200%" }}
                            transition={{
                                duration: 40,
                                repeat: Infinity,
                                ease: "linear",
                            }}
                        >

                            {[
                                {
                                    name: "HDFC Mutual Fund",
                                    logo: "Hdfc-Logo-Main.svg"
                                },
                                {
                                    name: "ICICI Prudential Mutual Fund",
                                    logo: "icic.jpg"
                                },
                                {
                                    name: "Nippon Mutual Fund",
                                    logo: "nipponindia-mutual-fund-logo.webp"
                                },
                                {
                                    name: "Care Health Insurance",
                                    logo: Care
                                },
                                {
                                    name: "Aditya Birla Capital",
                                    logo: "adityabirla.svg"
                                },
                                {
                                    name: "HDFC Life",
                                    logo: "HDFCLife25Yearslogo-min.png"
                                },
                                {
                                    name: "Nippon",
                                    logo: nippo
                                },
                                {
                                    name: "Star Health Insurance",
                                    logo: star
                                }, {
                                    name: "Max Bupa Health Insurance",
                                    logo: Max
                                },
                                {
                                    name: "Mirae Asset Mutual Fund",
                                    logo: Mirage
                                }

                            ].map((brand, index) => (
                                <motion.div
                                    key={`first-${index}`}
                                    className="brand-card d-flex flex-column align-items-center justify-content-center text-center"

                                    style={{
                                        minWidth: "140px",
                                        padding: "1rem 1.5rem",
                                        backgroundColor: "var(--white)",
                                        borderRadius: "12px",
                                        border: "1px solid var(--light-bg)",
                                        boxShadow: "0 4px 12px rgba(0, 119, 125, 0.08)",
                                        transition: "all 0.3s ease"
                                    }}
                                    whileHover={{
                                        backgroundColor: "var(--light-bg)",
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 8px 20px rgba(0, 119, 125, 0.15)",
                                        borderColor: "var(--primary)"
                                    }}
                                >
                                    <div
                                        style={{
                                            height: "40px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: "0.5rem"
                                        }}
                                    >
                                        <img
                                            src={brand.logo}
                                            alt={brand.name}
                                            className="brand-logo"
                                            style={{
                                                maxHeight: "40px",
                                                maxWidth: "100px",
                                                objectFit: "contain",
                                                filter: "grayscale(0.3)"
                                            }}
                                            onError={(e) => {
                                                // Fallback if image fails to load
                                                e.target.style.display = 'none';
                                                e.target.nextSibling.style.display = 'block';
                                            }}
                                        />
                                        <span
                                            style={{
                                                display: 'none',
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: 'var(--heading)'
                                            }}
                                        >
                                            {brand.name.split(' ')[0].charAt(0)}
                                        </span>
                                    </div>
                                    <span
                                        style={{
                                            color: "var(--heading)",
                                            fontSize: "0.85rem",
                                            fontWeight: "600",
                                            lineHeight: "1.2"
                                        }}
                                    >
                                        {brand.name}
                                    </span>
                                </motion.div>
                            ))}

                            {/* Duplicate set for seamless loop */}
                            {[
                                {
                                    name: "HDFC Mutual Fund",
                                    logo: "Hdfc-Logo-Main.svg"
                                },
                                {
                                    name: "ICICI Prudential Mutual Fund",
                                    logo: "icic.jpg"
                                },
                                {
                                    name: "Nippon Mutual Fund",
                                    logo: "nipponindia-mutual-fund-logo.webp"
                                },
                                {
                                    name: "Care Health Insurance",
                                    logo: Care
                                },
                                {
                                    name: "Aditya Birla Capital",
                                    logo: "adityabirla.svg"
                                },
                                {
                                    name: "HDFC Life",
                                    logo: "HDFCLife25Yearslogo-min.png"
                                },
                                {
                                    name: "Nippon",
                                    logo: nippo
                                },
                                {
                                    name: "Star Health Insurance",
                                    logo: star
                                }, {
                                    name: "Max Bupa Health Insurance",
                                    logo: Max
                                },
                                {
                                    name: "Mirae Asset Mutual Fund",
                                    logo: Mirage
                                }

                            ].map((brand, index) => (
                                <motion.div
                                    key={`second-${index}`}
                                    className="brand-card d-flex flex-column align-items-center justify-content-center text-center"

                                    style={{
                                        minWidth: "140px",
                                        padding: "1rem 1.5rem",
                                        backgroundColor: "var(--white)",
                                        borderRadius: "12px",
                                        border: "1px solid var(--light-bg)",
                                        boxShadow: "0 4px 12px rgba(0, 119, 125, 0.08)",
                                        transition: "all 0.3s ease"
                                    }}
                                    whileHover={{
                                        backgroundColor: "var(--light-bg)",
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 8px 20px rgba(0, 119, 125, 0.15)",
                                        borderColor: "var(--primary)"
                                    }}
                                >
                                    <div
                                        style={{
                                            height: "40px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: "0.5rem"
                                        }}
                                    >
                                        <img
                                            src={brand.logo}
                                            alt={brand.name}
                                            className="brand-logo"
                                            style={{
                                                maxHeight: "40px",
                                                maxWidth: "100px",
                                                objectFit: "contain",
                                                filter: "grayscale(0.3)"
                                            }}
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.nextSibling.style.display = 'block';
                                            }}
                                        />
                                        <span
                                            style={{
                                                display: 'none',
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: 'var(--heading)'
                                            }}
                                        >
                                            {brand.name.split(' ')[0].charAt(0)}
                                        </span>
                                    </div>
                                    <span
                                        style={{
                                            color: "var(--heading)",
                                            fontSize: "0.85rem",
                                            fontWeight: "600",
                                            lineHeight: "1.2"
                                        }}
                                    >
                                        {brand.name}
                                    </span>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>

                    {/* Second row moving in opposite direction */}
                    <div className="position-relative overflow-hidden py-4 mt-4">
                        {/* Gradient Overlays */}
                        <div
                            style={{
                                position: "absolute",
                                left: 0,
                                top: 0,
                                bottom: 0,
                                width: "100px",
                                background: "linear-gradient(90deg, var(--white) 0%, transparent 100%)",
                                zIndex: 2
                            }}
                        ></div>
                        <div
                            style={{
                                position: "absolute",
                                right: 0,
                                top: 0,
                                bottom: 0,
                                width: "100px",
                                background: "linear-gradient(270deg, var(--white) 0%, transparent 100%)",
                                zIndex: 2
                            }}
                        ></div>

                        {/* Moving Brands - Second Set (Reverse Direction) */}
                        <motion.div
                            className="brand-row d-flex align-items-center companybrand"
                            initial={{ x: "-200%" }}
                            animate={{ x: "0%" }}

                            transition={{
                                duration: 40,
                                repeat: Infinity,
                                ease: "linear",
                            }}
                        >

                            {[

                                {
                                    name: "Tata mutual Fund",
                                    logo: tata
                                },
                                {
                                    name: "Bajaj Allianz Life ",
                                    logo: Bajaj
                                },
                                {
                                    name: "Edelweiss mutual fund",
                                    logo: "end.png"
                                },
                                {
                                    name: "Kotak mutual fund",
                                    logo: "kotak.png"
                                },
                                {
                                    name: "Axis mutual fund",
                                    logo: "axis.png"
                                },
                                {
                                    name: "SBI mutual Fund",
                                    logo: "sbi.png"
                                },
                                {
                                    name: "Bandhan Mutual Fund",
                                    logo: Bandhan
                                },
                                {
                                    name: "SMC",
                                    logo: smc
                                }, {
                                    name: "Uti Mutual Fund",
                                    logo: Uti
                                }
                            ].map((brand, index) => (
                                <motion.div
                                    key={`reverse-${index}`}
                                    className="brand-card d-flex flex-column align-items-center justify-content-center text-center"

                                    style={{
                                        minWidth: "140px",
                                        padding: "1rem 1.5rem",
                                        backgroundColor: "var(--white)",
                                        borderRadius: "12px",
                                        border: "1px solid var(--light-bg)",
                                        boxShadow: "0 4px 12px rgba(0, 119, 125, 0.08)",
                                        transition: "all 0.3s ease"
                                    }}
                                    whileHover={{
                                        backgroundColor: "var(--light-bg)",
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 8px 20px rgba(0, 119, 125, 0.15)",
                                        borderColor: "var(--primary)"
                                    }}
                                >
                                    <div
                                        style={{
                                            height: "40px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: "0.5rem"
                                        }}
                                    >
                                        <img
                                            src={brand.logo}
                                            alt={brand.name}
                                            className="brand-logo"
                                            style={{
                                                maxHeight: "40px",
                                                maxWidth: "100px",
                                                objectFit: "contain",
                                                filter: "grayscale(0.3)"
                                            }}
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.nextSibling.style.display = 'block';
                                            }}
                                        />
                                        <span
                                            style={{
                                                display: 'none',
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: 'var(--heading)'
                                            }}
                                        >
                                            {brand.name.split(' ')[0].charAt(0)}
                                        </span>
                                    </div>
                                    <span
                                        style={{
                                            color: "var(--heading)",
                                            fontSize: "0.85rem",
                                            fontWeight: "600",
                                            lineHeight: "1.2"
                                        }}
                                    >
                                        {brand.name}
                                    </span>
                                </motion.div>
                            ))}

                            {/* Duplicate set for seamless loop */}
                            {[

                                {
                                    name: "Tata mutual Fund",
                                    logo: tata
                                },
                                {
                                    name: "Bajaj Allianz Life ",
                                    logo: Bajaj
                                },
                                {
                                    name: "Edelweiss mutual fund",
                                    logo: "end.png"
                                },
                                {
                                    name: "Kotak mutual fund",
                                    logo: "kotak.png"
                                },
                                {
                                    name: "Axis mutual fund",
                                    logo: "axis.png"
                                },
                                {
                                    name: "SBI mutual Fund",
                                    logo: "sbi.png"
                                }, {
                                    name: "Bandhan Mutual Fund",
                                    logo: Bandhan
                                }, {
                                    name: "Ppfas Mutual fund",
                                    logo: Ppfas
                                },
                                {
                                    name: "SMC",
                                    logo: smc
                                }, {
                                    name: "Uti Mutual Fund",
                                    logo: Uti
                                }
                            ].map((brand, index) => (
                                <motion.div
                                    key={`reverse-second-${index}`}
                                    className="brand-card d-flex flex-column align-items-center justify-content-center text-center"

                                    style={{
                                        minWidth: "140px",
                                        padding: "1rem 1.5rem",
                                        backgroundColor: "var(--white)",
                                        borderRadius: "12px",
                                        border: "1px solid var(--light-bg)",
                                        boxShadow: "0 4px 12px rgba(0, 119, 125, 0.08)",
                                        transition: "all 0.3s ease"
                                    }}
                                    whileHover={{
                                        backgroundColor: "var(--light-bg)",
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 8px 20px rgba(0, 119, 125, 0.15)",
                                        borderColor: "var(--primary)"
                                    }}
                                >
                                    <div
                                        style={{
                                            height: "40px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: "0.5rem"
                                        }}
                                    >
                                        <img
                                            src={brand.logo}
                                            alt={brand.name}
                                            className="brand-logo"
                                            style={{
                                                maxHeight: "40px",
                                                maxWidth: "100px",
                                                objectFit: "contain",
                                                filter: "grayscale(0.3)"
                                            }}
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.nextSibling.style.display = 'block';
                                            }}
                                        />
                                        <span
                                            style={{
                                                display: 'none',
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: 'var(--heading)'
                                            }}
                                        >
                                            {brand.name.split(' ')[0].charAt(0)}
                                        </span>
                                    </div>
                                    <span
                                        style={{
                                            color: "var(--heading)",
                                            fontSize: "0.85rem",
                                            fontWeight: "600",
                                            lineHeight: "1.2"
                                        }}
                                    >
                                        {brand.name}
                                    </span>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </div>
            </section>
        </div>

    );
};

export default Home;
